<app-skill-builder-select-list
	[mainTitle]="page.title"
	[custom]="custom"
	[subTitle]="page.subTitle"
	[options]="options"
	[max]="max"
	[next]="next"
>
</app-skill-builder-select-list>
